import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "../redux";
import { getDefaultRouteByRole } from "./getDefaultRouteByRole";

export const RoleBasedRedirect = () => {
  const user = useSelector(selectUser);
  return <Navigate to={getDefaultRouteByRole(user?.role)} replace />;
};
